function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.195 5a1 1 0 00-.995.899l-1.223 12A1 1 0 005.97 19h12.057a1 1 0 00.995-1.101l-1.223-12A1 1 0 0016.805 5h-9.61zm0-2h9.61a3 3 0 012.985 2.696l1.223 12A3 3 0 0118.028 21H5.971a3 3 0 01-2.984-3.304l1.223-12A3 3 0 017.195 3zM8 8a1 1 0 112 0 2 2 0 104 0 1 1 0 012 0 4 4 0 11-8 0z"
});

var SvgShop = function SvgShop(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/shop.e63e2aa6.svg";
export { SvgShop as ReactComponent };